const NOTIFICATION_TYPES = {
	ADD: 'NOTIFICATION/ADD',
	CLEAN: 'NOTIFICATION/CLEAN',
};

export default NOTIFICATION_TYPES;
